var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yk-code"},[_c('img',{staticClass:"notice-img",attrs:{"src":require("../../static/assets/image/notice-icon.png")},on:{"click":_vm.handleNoticeClick}}),_vm._v(" "),_c('img',{staticClass:"code-img",attrs:{"src":require("../../static/assets/image/yk-code.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19115cbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/h-code.vue
// module id = null
// module chunks = 